export default "__VITE_ASSET__B3Sse9M7__"